/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './toast.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../svg-icon/svg-icon.component.ngfactory';
import * as i3 from '../../../../app/shared/svg-icon/svg-icon.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/shared/toast/toast.component';
const styles_ToastComponent:any[] = [i0.styles];
export const RenderType_ToastComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ToastComponent,data:{}});
function View_ToastComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class',
      'no-style close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.hide()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',[['name','close']],(null as any),
          (null as any),(null as any),i2.View_SvgIconComponent_0,i2.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i3.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        const currVal_0:any = 'close';
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
export function View_ToastComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'message']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastComponent_1)),
      i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i5.ToastComponent = _v.component;
    const currVal_1:any = _co.showCloseButton;
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.ToastComponent = _v.component;
    const currVal_0:any = _co.message;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ToastComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'toast',([] as any[]),
      (null as any),(null as any),(null as any),View_ToastComponent_0,RenderType_ToastComponent)),
      i1.ɵdid(49152,(null as any),0,i5.ToastComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any))],(null as any),(null as any));
}
export const ToastComponentNgFactory:i1.ComponentFactory<i5.ToastComponent> = i1.ɵccf('toast',
    i5.ToastComponent,View_ToastComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvdG9hc3QvdG9hc3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3RvYXN0L3RvYXN0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3RvYXN0L3RvYXN0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvdG9hc3QvdG9hc3QuY29tcG9uZW50LnRzLlRvYXN0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIm1lc3NhZ2VcIj57e21lc3NhZ2V9fTwvZGl2PlxyXG5cclxuPGJ1dHRvbiBjbGFzcz1cIm5vLXN0eWxlIGNsb3NlLWJ1dHRvblwiICpuZ0lmPVwic2hvd0Nsb3NlQnV0dG9uXCIgKGNsaWNrKT1cImhpZGUoKVwiPlxyXG4gICAgPHN2Zy1pY29uIG5hbWU9XCJjbG9zZVwiPjwvc3ZnLWljb24+XHJcbjwvYnV0dG9uPiIsIjx0b2FzdD48L3RvYXN0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNFQTtNQUFBO0lBQUE7SUFBQTtJQUE4RDtNQUFBO01BQUE7SUFBQTtJQUE5RDtFQUFBLGdDQUErRSwyQ0FDM0U7YUFBQTtVQUFBO2FBQUE7VUFBQSxpQ0FBa0M7O1FBQXhCO1FBQVYsV0FBVSxTQUFWOzs7O29CQUhKO01BQUE7TUFBcUIsd0NBQWlCO01BRXRDO2FBQUE7VUFBQTs7SUFBc0M7SUFBdEMsV0FBc0MsU0FBdEM7OztJQUZxQjtJQUFBOzs7O29CQ0FyQjtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/toast/toast.component.ngfactory.ts